// Invert a single operation.
function invertComponent(c) {
  var c_ = { p: c.p };

  if (c.hasOwnProperty("co")) {
    c_.do = c.co;
  } else if (c.hasOwnProperty("do")) {
    c_.co = c.do;
  } else if (c.hasOwnProperty("cp")) {
    c_.cp = c.dp;
    c_.dp = c.cp;
  } else if (c.hasOwnProperty("cs")) {
    c_.ds = c.cs;
  } else if (c.hasOwnProperty("ds")) {
    c_.cs = c.ds;
  }

  return c_;
}

// Invert an array of operations.
function invert(op) {
  op = op.slice().reverse();
  for (var i = 0; i < op.length; i++) {
    op[i] = invertComponent(op[i]);
  }
  return op;
}

export { invertComponent };
export default invert;
